module.exports = __webpack_public_path__ + "static/img/pdf_bg.16e27b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pdf_bg.png
// module id = c2I2
// module chunks = 1